import { createContext, useContext } from 'react';
import { gql } from '@apollo/client';

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(input: { email: $email, password: $password }) {
      token
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation register($username: String!, $email: String!, $password: String!) {
    register(input: { username: $username, email: $email, password: $password }) {
      user {
        id
      }
    }
  }
`;

export interface AuthState {
  loading: boolean;
  error: string | null;
}

export type AuthAction =
  | { type: 'AUTH_REQUEST' }
  | { type: 'AUTH_SUCCESS' }
  | { type: 'AUTH_FAILURE'; payload: string };

export const initialState: AuthState = { loading: false, error: null };

export const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'AUTH_REQUEST':
      return { ...state, loading: true, error: null };
    case 'AUTH_SUCCESS':
      return { ...state, loading: false, error: null };
    case 'AUTH_FAILURE':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const AuthContext = createContext<
  | (AuthState & {
      login: (variables: any) => Promise<any>;
      logout: () => Promise<void>;
      register: (variables: any) => Promise<any>;
    })
  | undefined
>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
